import { _ } from "ynf-core-middleware";
import { v4 as uuid } from "uuid";
import { makeAutoObservable, observable, reaction, toJS } from "mobx";
import { RowStore } from "./row/RowStore";
import { BaseRowStore } from "./row/BaseRowStore";
import { ColumnsType, DataState, _STATUS, TABLE, ID } from "./types";
import { ColumnFactory } from "./columns/ColumnFactory";
import { PARENT_ROW_KEY } from "../cardstore/constants";
import { BaseColumn } from './columns/BaseColumn'
import { CharacterColumn } from "./columns/CharacterColumn";
const PageStatusType = {
  INIT: "init",
  EDIT: "edit",
  BROWSE: "browse",
  ADD: "add"
};
export class TableStore {
  /** 行数据集合 */
  data: Array<BaseRowStore<any>>;
  dirtyData: Array<any> | undefined;
  /** 列数据 */
  columns: Map<string, BaseColumn>;
  afterInitColumns: string;
  /** 当前滑过行 */
  currentHoverRowKey: string | number;
  /** 当前激活行 */
  currentActiveRowKey: string | number;
  /** 当前状态 */
  uiState: string;
  /** store类型 */
  storeType: string;
  // 是否展开收起行按钮
  isFoldMenu: boolean;
  _isFoldMenu: any;
  // 根Store
  rootStore: any;
  // 显示选中内容
  showSelect: boolean;
  // 显示隐藏
  visible: boolean;
  // 只读
  $readOnly: boolean;
  // 扩展的rowStore 类
  extendRowStore: any;

  filters: Array<any>;

  hooks: any;

  caption: string;

  // 数据主键 key
  primaryKey: string;

  // 主组织id字段
  fieldsArr: Array<Object>;

  // 多页选择存储数据
  multiplePageSelectedData: Array<BaseRowStore<any>>;
  // 是否开启跨页选择
  multiplePageSelected: boolean;

  characterEffects?: {
    [key: string]: string[];
  };
  // 单据页主表的key
  formStoreKey?: string;
  // 单据页子表数据源
  dataSource?: string;
  // tableStore的key
  alias: string;
  constructor(
    storeParams?: any,
    rootStore?: any,
    extendRowStore?: any,
    primaryKey?: string
  ) {
    this.caption = storeParams?.caption;
    this.alias = storeParams?.alias;
    // 初始化参数,扩展类不传入的话，默认RowStore
    this.extendRowStore = extendRowStore || RowStore;
    this.primaryKey = primaryKey || ID;
    this.rootStore = rootStore;
    this.storeType = TABLE;
    this.currentHoverRowKey = "";
    this.currentActiveRowKey = "";
    this.showSelect = false;
    this.isFoldMenu = false;
    this._isFoldMenu = undefined;
    this.filters = [];
    this.fieldsArr = []
    this.multiplePageSelected = true;
    // eslint-disable-next-line no-array-constructor
    this.data = new Array<BaseRowStore<any>>();
    // eslint-disable-next-line no-array-constructor
    this.multiplePageSelectedData = new Array<BaseRowStore<any>>();
    this.columns = observable.map();
    this.afterInitColumns = uuid();
    this.uiState = PageStatusType.BROWSE;
    this.visible = true;
    this.$readOnly = false;
    this.dirtyData = undefined;
    this.hooks = {};
    makeAutoObservable(
      this,
      {
        rootStore: false,
        // 设置RowStore类支持扩展，不能响应
        extendRowStore: false,
        hooks: false,
        dirtyData: false,
        // afterInitColumns: false,
        // multiplePageSelectedData: false,
        multiplePageSelected: false
      },
      { autoBind: true }
    );
    // 合并数据实体和UI实体对象
    if (storeParams?.fieldsArr && Array.isArray(storeParams?.fieldsArr)) {
      this.initColumns(storeParams.fieldsArr);
    }
    // this.setHooks(AFTER_SET_VALUE, () => {
    //   this.useCharacterEffects();
    // });
    reaction(
      () => this.afterInitColumns,
      (afterInitColumns: any) => {
        if (afterInitColumns) this.useCharacterEffects();
      }
    );
    reaction(
      () => this.isEdit,
      (value: any) => {
        if (value) {
          this.dirtyData = _.cloneDeep(this.dataToJson())
        }
      }
    );
    reaction(
      () => this.readOnly,
      (value: any) => {
        if (value && typeof this._isFoldMenu === "boolean") {
          this.isFoldMenu = this._isFoldMenu
          this._isFoldMenu = undefined
        } else {
          this._isFoldMenu = this.isFoldMenu;
          this.isFoldMenu = true
        }
      }
    );
  }

  cancelEdit() {
    if (this.dirtyData) {
      this.setValue(this.dirtyData)
      this.dirtyData = undefined
    } else {
      // 行编辑表 存在浏览态直接进行新增取消
      const data = this.data.filter(row => row.get_Status() != DataState.Insert)
      this.setValue(data.map(row => row.dataEntityToJson()))
    }
    this.setUiState(PageStatusType.BROWSE)
  }

  useCharacterEffects() {
    // 如果有特征副作用, 且处于浏览态, 请求接口
    if (!this.afterInitColumns || !this.characterEffects) return;
    for (const referField in this.characterEffects) {
      const characterFields = this.characterEffects[referField];
      const referFieldIds = this.data.map((rowStore) =>
        rowStore.getTrueValue(referField)
      );
      const ids = Array.from(new Set(referFieldIds)).filter((id) =>
        Boolean(id)
      );
      const types = characterFields.map((characterField) => {
        return (this.columns.get(characterField) as CharacterColumn)?.type;
      });
      const characterStore = this.rootStore.pageStore.characterStore;
      characterStore.getCharacterDesc(ids, types);
    }
  }

  /**
   * 获取所有跨页选择的数据，只要不取消选择，都在
   * @returns 返回所有跨页
   */
  getMultiplePageSelectedData() {
    return this.multiplePageSelectedData;
  }

  /**
   * 设置hooks
   * @param hookPoint key
   * @param hookImpl function
   */
  setHooks(hookPoint: string, hookImpl: Function): void {
    if (!this.hooks[hookPoint]) this.hooks[hookPoint] = [];
    this.hooks[hookPoint].push(hookImpl);
  }

  /**
   * 设置过滤器
   * @param filter 过滤器 function
   */
  addFilter(filter: Function): void {
    if (!_.isFunction(filter)) return;
    this.filters.push(filter);
  }

  /**
   * 移除过滤器
   * @param filter 过滤器 function
   */
  removeFilter(filter: Function): void {
    const filters = this.filters;
    let index = filters.length;
    while (index--) {
      if (filter === filters[index]) {
        this.filters.splice(index, 1);
        break;
      }
    }
  }

  /**
   * 设置展开收起 toggle
   */
  setFoldMenu(): void {
    this.isFoldMenu = !this.isFoldMenu;
  }

  // 初始化列
  initColumns(children: Array<ColumnsType>) {
    this.fieldsArr = children
    children?.forEach((column: any, index) => {
      column.dataIndex = index;
      if (column.children && column.children?.length > 0) {
        this.addColumnsForLeafNodes(column)
      } else {
        this.addColumns(column)
      }
    });
    this.afterInitColumns = uuid();
    this.data.forEach((row) => row.initValidators());
  }

  // 针对多列表头叶子节点column的初始化
  private addColumnsForLeafNodes(column: any) {
    if (column.children) {
      column?.children?.forEach((childColumn: any) => {
        if (childColumn?.children) {
          this.addColumnsForLeafNodes(childColumn); // 递归调用处理子节点
        } else {
          this.addColumns(childColumn); // 处理叶子节点
        }
      });
    }
}

  /**
   * 设置是否显示选中数据
   */
  setShowSelect(): boolean {
    this.showSelect = !this.showSelect;
    return this.showSelect;
  }

  /**
   * 添加行数据
   * @param row row 数据对象 or RowStore
   * @param isInit 是否是初始化，默认不填写
   * @returns 行数据
   */
  addRow(row: any, isInit: boolean = false): BaseRowStore<any> {
    // 插入行，设置数据标识
    const rowStore: BaseRowStore<any> = this.parseRow(row);
    if (!isInit) {
      rowStore.set_Status(DataState.Insert);
    }
    this.data.push(rowStore);
    this.resetOrder()
    this.hooks.afterAddRow?.forEach((fn: Function) => {
      fn?.(rowStore);
    });
    return rowStore;
  }

  // 转换行
  private parseRow(row: any): BaseRowStore<any> {
    if (row instanceof BaseRowStore) {
      row = toJS(row.data);
    }
    // 树结构处理-移动到row上处理
    // if (data.children && Array.isArray(data.children) && data.children.length) {
    //   data.children = data.children.map((item: any) => {
    //     return this.parseRow(item, isEntity);
    //   });
    // }
    // 如果有扩展的rowStore类，new 扩展的,没有 new 自己的。
    // if (this.extendRowStore) {
    // eslint-disable-next-line new-cap
    return new this.extendRowStore(this, row);
  }

  private resetOrder() {
    this.data.map((row, index) => row.order = index)
  }

  /**
   * 创建空行
   * @returns 创建的空行
   */
  createEmptyRowData(): BaseRowStore<any> {
    const empty: BaseRowStore<any> = this.parseRow({});
    // const empty: any = {};
    for (const key of this.columns.keys()) { // 追加默认值
      const columns = this.columns.get(key)
      // if (columns?.defaultValue && columns?.selectType === 'single') {
      //   _.assign(empty, columns.defaultValue);
      // } else {
      //   columns?.defaultValue && _.set(empty, key, columns.defaultValue)
      // }
      columns?.defaultValue && columns?.setValue(columns.defaultValue, empty)
      // columns?.defaultValue && _.set(empty, key, columns.defaultValue)
      // empty[key] = this.columns.get(key)?.defaultValue;// 特征是对象
    }
    return empty;
  }

  /**
   * 添加空行
   * @returns rowStore
   */
  addEmptyRow(): BaseRowStore<any> {
    const newRow = this.addRow(this.createEmptyRowData());
    return newRow;
  }

  /**
   * 添加空行
   * @returns rowStore
   */
  addEmptyEditRow(): BaseRowStore<any> {
    const newRow = this.addEmptyRow()
    newRow.setReadOnly(false)
    return newRow;
  }

  /**
   * 更新行
   * @param rowKey
   * @param any 行数据
   */
  updateRow(rowKey: number | string, rowStore: any): void {
    const nextRowStore = this.parseRow(rowStore);
    this.next(this.data, (rowStore: any, index: number, data: BaseRowStore<any>[]) => {
      if (rowStore.rowKey === rowKey) {
        data[index] = nextRowStore;
      }
    });
    if ([DataState.Unchanged, undefined].includes(nextRowStore.get_Status())) {
      nextRowStore.set_Status(DataState.Update);
    }
  }

  /**
   * 删除行（物理删）
   * @param item rowStore
   * @returns boolean
   */
  dropRow(item: BaseRowStore<any>): boolean {
    const index = this.data.indexOf(item);
    if (!~index) return false;
    this.spliceData(index, 1);
    this.removeMultiplePageSelectedDataByRowKeys([item.rowKey]);
    return true;
  }

  /**
   * 按行号删除行（物理删）
   * @param item rowStore
   * @returns boolean
   */
  dropRowByIndex(index: number) {
    this.removeMultiplePageSelectedDataByRowKeys([this.data[index].rowKey]);
    this.spliceData(index, 1);
  }

  /**
   * 删除行
   * @param item  row
   * @returns
   */
  deleteRow(item: BaseRowStore<any>) {
    if (item.get_Status() === DataState.Insert) {
      return this.dropRow(item);
    }
    item.set_Status(DataState.Delete)
    // 删除后，检查跨页多选数据里面是否有，删除
    this.removeMultiplePageSelectedDataByRowKeys([item.rowKey]);
    this.hooks?.afterRowSetValue?.forEach?.((fn: Function) => fn(item));
  }

  /**
   * 批量删除行数据
   * @param rowKeys
   */
  batchDeleteByRowKeys(rowKeys: string[]) {
    const data: BaseRowStore<any>[] = [];
    this.data.forEach((item) => {
      if (rowKeys.indexOf(item.rowKey) < 0) {
        data.push(item);
      }
    });
    this.data = data;
    this.resetOrder()
    // 删除
    this.removeMultiplePageSelectedDataByRowKeys(rowKeys);
  }

  /**
   * 删除行
   * @param key 根据key 删除行
   */
  deleteRowByRowKey(key: string): void {
    const rows = this.data.filter((item: any) => item.rowKey === key);
    if (rows.length) {
      this.deleteRow(rows[0]);
    }
    // this.deleteRowByIndex(this.findIndexByRowKey(key));
  }

  /**
   * 根据rowkey 查找index,只能处理第一级，不能处理树形结构，不推荐使用
   * @param key key
   * @returns number
   */
  findIndexByRowKey(key: string | number): number {
    // 修改bug， 去掉 || -1 第0个元素 index = 0 取不到
    return this.data.findIndex(({ rowKey }) => rowKey === key);
  }

  private spliceData(start: number, deleteCount: number, row?: BaseRowStore<any>) {
    if (row) {
      this.data.splice(start, deleteCount, row)
    } else {
      this.data.splice(start, deleteCount)
    }
    this.resetOrder()
  }

  /**
   * 设置只读
   * @param b boolean
   */
  setReadOnly(b: boolean) {
    this.$readOnly = b;
  }

  /**
   * 获取行
   * @param index 行号
   * @returns rowStore
   */
  getRow(index: number): BaseRowStore<any> {
    this.checkIsNull(index, "getRow");
    return this.data[index];
  }

  /**
   * 根据rowKey 获取行
   * @param rowKey rowKey
   * @returns RowStore
   */
  getRowByKey(rowKey: string | number): BaseRowStore<any> | undefined {
    let rowStore: BaseRowStore<any> | undefined;
    this.next(this.data, (item: BaseRowStore<any>) => {
      if (item.rowKey === rowKey) {
        rowStore = item;
      }
    });
    return rowStore;
    // return this.getRow(this.findIndexByRowKey(rowKey));
  }

  /**
   * TODO 需修改减少提供万能方法
   * 获取全部数据
   * @returns 获取全部数据
   */
  getRows({ withFilter = true } = {}): Array<BaseRowStore<any>> {
    const data = withFilter ? this.filterData() : this.data;
    return data
  }

  /**
   * TODO 需修改减少提供万能方法
   * 获取全部数据
   * @returns 获取全部数据
   */
  getValue({ withFilter = true } = {}): Array<BaseRowStore<any>> {
    const data = withFilter ? this.filterData() : this.data;
    return this.showSelect ? this.filterSelectValue(data) : this.filterByDeleteStatus(data);
  }

  filterData() {
    let data = this.data;
    if (this.filters.length) {
      for (let filter of this.filters) {
        if (filter.fn) filter = filter.fn;
        data = data.filter(filter);
      }
    }
    return data
  }

  filterByStatus(data: BaseRowStore<any>[], ..._status: string[]) {
    const newData = data || this.data
    return newData.filter((row: any) => _status.includes(row.get_Status()))
  }

  filterByDeleteStatus(data: BaseRowStore<any>[]) {
    const newData = data || this.data
    return newData.filter((row: any) => row.get_Status() !== DataState.Delete)
  }

  filterSelectValue(data: BaseRowStore<any>[]) {
    const newData = data || this.data
    return newData.filter((row) => row.selected)
  }

  getStoreValue() {
    return this.getValue()?.map?.(item => item.dataToJson?.()) || []
  }

  /***
   * 清空状态，insert Update delete 处理数据
   */
  clearStatus(): void {
    const data: any = [];
    this.data.forEach((row) => {
      if (!row.isDeleteState()) {
        row.deleteState()
        data.push(row);
      }
    });
    this.setValue(data);
  }

  /**
   *
   * @param rowStore 检查是否有跨页多选
   */
  checkMultipleChangeSelect(rowStore: BaseRowStore<any>) {
    if (this.multiplePageSelected) {
      const isHaveSelectData = this.multiplePageSelectedData.filter(
        (selectRowStore: BaseRowStore<any>) => rowStore.getValue(this.primaryKey) ===
          selectRowStore.getValue(this.primaryKey)
      );
      if (isHaveSelectData.length) {
        rowStore.selected = true;
        isHaveSelectData[0].data = rowStore.data;
      }
    }
  }

  /**
   * 设置全部数据
   * @param list list Object
   * @param isEntity Boole 是否来自ypd实体修改数据
   */
  setValue(list: Array<Object> = [], _isEntity = false): void {
    const newData: BaseRowStore<any>[] = [];
    list.forEach((element, index) => {
      const rowStore = this.parseRow(element) as BaseRowStore<any>;
      // 如果开启跨页多选，根据主键处理新来的数据是否选择
      this.checkMultipleChangeSelect(rowStore);
      newData.push(rowStore);
      rowStore.order = index
    });
    this.data = newData;
    // 设置数据后的钩子函数
    this.hooks.afterSetValue?.forEach((fn: Function) => {
      fn?.(this.data);
    });
  }

  /**
   * 插入行
   * @param index index
   * @param row row数据
   * @returns rowStore
   */
  insertRow(index: number, row: any, parentRowKey?: string): BaseRowStore<any> {
    this.checkIsNull(index, "insertRow");
    // 插入行，设置数据标识
    const rowStore: BaseRowStore<any> = this.parseRow(row);
    rowStore.set_Status(DataState.Insert);
    rowStore.data[this.primaryKey] = "";
    if (parentRowKey) {
      rowStore.data[PARENT_ROW_KEY] = parentRowKey;
    }
    this.spliceData(index, 0, rowStore);
    this.hooks.afterAddRow?.forEach((fn: Function) => {fn?.(rowStore)});
    this.hooks?.afterRowSetValue?.forEach?.((fn: Function) => fn(rowStore));
    return rowStore;
  }

  /**
   * 获取某列数据的集合
   * @param key key
   * @returns list 数组
   */
  getColumnData(key: string): any {
    const data: any = [];
    this.data.forEach((rowStore) => {
      const value = rowStore.getValue(key);
      value && data.push(value);
    });
    return data;
  }

  /**
   * 获取选中行
   * @returns 获取选中行
   */
  getSelectedRows(): Array<BaseRowStore<any>> | [] {
    if (this.multiplePageSelected) {
      return this.getMultiplePageSelectedData();
    }
    return this.getValue().filter((rowStore) => rowStore.selected);
  }

  /**
   * 依据index选中操作
   * @param index
   */
  selectedByIndex(index: number) {
    const rowStore = this.getRow(index);
    rowStore.setSelected();
    // 如果开启跨页多选，选择的数据存储到multiplePageSelectedData 中
    // 去rowStore 里面统一处理
    // this.multiplePageSelected && this.multiplePageSelectedData.push(rowStore);
  }

  // setSelectRowKeys(keys: Array<string>) {
  //   this.data.forEach(rowStore => {
  //     if(keys.includes(rowStore.rowKey)){
  //       rowStore.setSelected()
  //     }else{
  //       rowStore.setSelected(false)
  //     }
  //   })
  // }
  /**
   * 根据行号选中
   * @param key rowKey
   */
  selectedByRowKey(key: string | number) {
    const rowStore = this.getRowByKey(key);
    // 如果开启跨页多选，选择的数据存储到multiplePageSelectedData 中
    rowStore?.setSelected();
    // if (rowStore && this.multiplePageSelected) {
    //   this.multiplePageSelectedData.push(rowStore);
    // }
    // this.selectedByIndex(this.findIndexByRowKey(key));
  }

  /**
   * 选择某行数据
   * @param row rowStore
   */
  selected(row: BaseRowStore<any>) {
    this.selectedByRowKey(row.rowKey);
  }

  /**
   * 取消选中根据index
   * @param index
   */
  unSelectedByIndex(index: number) {
    const unRowStore = this.getRow(index);
    unRowStore.setSelected(false);
    // 如果开启跨页多选后，处理数据,
    // if (this.multiplePageSelected && unRowStore) {
    //   // this.multiplePageSelectedData = this.multiplePageSelectedData.filter(
    //   //   (rowStore: RowStore) => {
    //   //     return (
    //   //       rowStore.getValue(this.primaryKey) !==
    //   //       unRowStore.getValue(this.primaryKey)
    //   //     );
    //   //   }
    //   // );
    //   this.removeMultiplePageSelectedDataByRowKeys([unRowStore.rowKey]);
    // }
  }

  /**
   * 取消选中根据index
   * @param key rowKey
   */
  unSelectedByRowKey(key: string) {
    const unRowStore = this.getRowByKey(key);
    unRowStore?.setSelected(false);
    // if (this.multiplePageSelected && unRowStore) {
    //   // this.multiplePageSelectedData = this.multiplePageSelectedData.filter(
    //   //   (rowStore: RowStore) => {
    //   //     return (
    //   //       rowStore.getValue(this.primaryKey) !==
    //   //       unRowStore.getValue(this.primaryKey)
    //   //     );
    //   //   }
    //   // );
    //   this.removeMultiplePageSelectedDataByRowKeys([unRowStore.rowKey]);
    // }
    // // this.unSelectedByIndex(this.findIndexByRowKey(key));
  }

  /**
   * 根据rowKey 删除跨页多选
   * @param rowKeys 根据rowKey 删除跨页多选
   */
  removeMultiplePageSelectedDataByRowKeys(rowKeys: string[]) {
    if (this.multiplePageSelected) {
      const newData: BaseRowStore<any>[] = [];
      this.multiplePageSelectedData.forEach((item) => {
        if (rowKeys.indexOf(item.rowKey) < 0) {
          newData.push(item);
        }
      });
      this.multiplePageSelectedData = newData;
    }
  }

  // 清空所有选择数据，包括跨页多选
  clearMultiplePageSelectedData() {
    this.unSelectAll();
    this.multiplePageSelectedData = [];
  }

  /**
   * 取消选择
   * @param row RowStore
   */
  unSelected(row: BaseRowStore<any>) {
    this.unSelectedByRowKey(row.rowKey);
  }

  /**
   * 全选
   */
  selectAll() {
    this.next(this.getValue(), (rowStore: BaseRowStore<any>) => {
      rowStore.setSelected(true);
    });
  }

  /**
   * 取消全选
   */
  unSelectAll() {
    // 递归取消选中，不能用unSelectedByRowKey 因为unSelectedByRowKey 里面会把跨页多选的删除掉。
    this.next(this.getValue(), (rowStore: BaseRowStore<any>) => {
      rowStore.setSelected(false);
    });
  }

  /**
   * 设置hoverRowKey
   * @param rowKey
   */
  setHoverRowKey(rowKey: string | number) {
    this.currentHoverRowKey = rowKey;
  }

  /**
   * 设置激活的行key
   * @param rowKey
   */
  setActiveRowKey(rowKey: string | number) {
    this.currentActiveRowKey = rowKey;
  }

  /**
   * 设置UI state
   * @param state add edit init browse
   * @returns
   */
  setUiState(state: string): void {
    let readOnly: boolean = true;
    // 如果是 编辑 或者 新增态，readOnly 为false，设置rowStore
    if (state === PageStatusType.EDIT || state === PageStatusType.ADD) {
      readOnly = false;
    }
    this.data.forEach((row) => row.setReadOnly(readOnly));
    this.uiState = state;
  }

  getColumn(key: any): BaseColumn | undefined {
    return this.columns.get(key)
  }
  /**
   * 添加列
   * @param src Column
   * @returns
   */
  addColumns(src: ColumnsType) {
    const storeAlias = ColumnFactory.getStoreAlias(src)
    if (!storeAlias) {
      console.log(`请检查传入columns参数${src}, 参数必须为{storeAlias : xxx}`)
      return
      // throw new Error(); // @notranslate
    }
    let column = this.columns.get(storeAlias)
    if (column) {
      column = ColumnFactory.updateColumn(column, src, this)
    } else {
      column = ColumnFactory.buildColumn(storeAlias, src, this)
    }
    this.columns.set(storeAlias, column);
    /**
     * 数据会比table 更新 column 早一些，老数据字段中没有 dataSourceAlias storeAlias
     * 导致一开始设置的store数据会存放key值 是field
     */
    // this.convertReferField2StoreAlias(storeAlias, column)
    return column
  }
  // private convertReferField2StoreAlias(storeAlias: string, column: BaseColumn) {
  //   if (!isRefer(column.controlType)) return
  //   this.data.map(row => {
  //     if (column.field && row.getTrueValue(column.field))
  //       row.setTrueValue(storeAlias, row.getTrueValue(column.field))
  //   })
  // }

  /**
   * dataToJson 格式化table数据
   * @returns json
   */
  dataToJson(): any {
    return this.data.map((value) => {
      return value.dataToJson();
    });
  }

  /**
   * 有数据变动的行 */
  getChangedRows() {
    return this.filterByStatus(this.data, DataState.Insert, DataState.Update, DataState.Delete)
  }

  /**
   * 后端传递，用带的数据格式
   * filterChange 有更改的数据
   *  */
  dataEntityToJson(): any {
    const rows = this.data.map((value) => {
      return value.dataEntityToJson();
    })
    return rows
  }

  getEntityValue() {
    return this.dataEntityToJson()
  }

  private checkIsNull(value: any, src: string = "") {
    if (value === undefined) {
      throw new Error(`${src}: 参数不允许为${value}`); // @notranslate
    }
  }

  /**
   * 设置选择的值,常用场景，供组件选择使用
   * @param rows 行数组
   */
  setSelectRowKeys(rows: [string | number] | [] = []): void {
    // 清空设置所有状态为false
    this.unSelectAll();
    // 设置新数据为selected状态
    rows.forEach((row) => {
      this.getRowByKey(row)?.setSelected();
    });
  }

  /**
   * 清空table 数据
   */
  clear(): void {
    this.data = [];
  }

  /**
   * 校验
   * @returns 校验结果
   */
  validate() {
    const result: any = [];
    this.getValue().forEach((row: BaseRowStore<any>) => {
      result.push(row.validate());
    });
    return result || [];
  }

  /**
   * 设置显示隐藏
   * @param b boolean
   */
  setVisible(b: boolean): void {
    this.visible = b;
  }

  // 递归数据
  next(data: Array<BaseRowStore<any>>, callBack: Function) {
    data.forEach((item: BaseRowStore<any>, index: number) => {
      callBack && callBack(item, index, data);
      if (item.children && item.children.length) {
        this.next(item.children, callBack);
      }
    });
  }

  // 反选
  invert() {
    this.next(this.getValue(), (item: BaseRowStore<any>) => {
      // 如果选中，调用，取消选中，反之，调用选中，兼容跨页多选
      if (item.selected) {
        this.unSelectedByRowKey(item.rowKey);
      } else {
        this.selectedByRowKey(item.rowKey);
      }
      // item.setSelected(!item.selected);
    });
  }

  setEntityValue(list: Array<Object> = []) {
    this.setValue(list, true)
  }

  // --------------------计算属性------------------------

  get isBrowse() {
    return this.uiState === PageStatusType.BROWSE;
  }

  get isEdit() {
    return this.uiState === PageStatusType.ADD || this.uiState === PageStatusType.EDIT || this.uiState === PageStatusType.INIT;
  }

  get isAdd() {
    return this.uiState === PageStatusType.ADD
  }

  /**
   * 获取选中的行的keys
   */
  get getSelectRowKeys() {
    const data = this.getValue();
    const result: string[] = [];
    this.next(data, (rowStore: BaseRowStore<any>) => {
      rowStore.selected && result.push(rowStore.rowKey);
    });
    return result;
  }

  /**
   * 获取当前hover行
   */
  get currentHoverRow(): BaseRowStore<any> | undefined {
    if (!this.currentHoverRowKey) {
      console.error(`未使用setHoverRowKey, 设置当前行`);
    }
    return !this.currentHoverRowKey
      ? undefined
      : this.getRowByKey(this.currentHoverRowKey);
  }

  /**
   * 获取激活的row
   */
  get currentActiveRow(): BaseRowStore<any> | undefined {
    if (!this.currentActiveRowKey) {
      console.error(`未使用setActiveRowKey, 设置当前行`);
    }
    return !this.currentActiveRowKey
      ? undefined
      : this.getRowByKey(this.currentActiveRowKey);
  }

  /**
   * 获取是否只读
   */
  get readOnly(): boolean {
    // 如果协议里面设置了不是只读的话，再check uiState看是不是browse
    if (this.$readOnly === false) {
      return this.uiState === PageStatusType.BROWSE;
    } else {
      return this.$readOnly;
    }
  }

  /**
   * 获取数据数量
   */
  get size(): number {
    return this.getValue().length;
  }

  /**
   * 获取选中数量，如果开启跨域多选，则包含跨页多选的数量
   */
  get selectSize(): number {
    return this.getSelectedRows().length;
  }

  /**
   * 是否只显示选择数据
   */
  get getShowSelect(): boolean {
    return this.showSelect;
  }

  /**
   * 是否展开收起行按钮
   */
  get getFoldMenu(): boolean {
    return this.isFoldMenu;
  }

  /**
   * 是否隐藏
   */
  get getVisible(): boolean {
    return this.visible;
  }

  /**
   * 是否全选
   */
  get isAllSelected(): number | boolean {
    // console.log("isAllSelected");
    return (
      this.getSelectRowKeys.length &&
      this.getSelectRowKeys.length === this.getValue()?.length
    );
  }

  /**
   * 是否部分选中
   */
  get indeterminate(): boolean {
    // console.log("indeterminate");
    return (
      this.getSelectRowKeys.length !== 0 &&
      this.getSelectRowKeys.length !== this.getValue().length
    );
  }

  /**
   * 拍平的RowStore data
   *  */
  get flatValue(): Array<any> {
    const flattenData: Array<any> = [];

    const flattenRow = (rowStore: BaseRowStore<any>) => {
      const rowValue = { ...rowStore.getValue(), rowKey: rowStore.rowKey, rowStore };

      if (rowStore.data.children && rowStore.data.children.length > 0) {
        rowValue.children = rowStore.data.children.map((childRowStore: BaseRowStore<any>) => {
          return flattenRow(childRowStore);
        });
      }
      return rowValue
    };

    this.getValue().forEach((rowStore) => {
      flattenData.push(flattenRow(rowStore));
    });

    return flattenData;
  }

  /**
   * 是否有更改的行
   *  */
  get hasChangedRows(): Array<any> {
    // @ts-ignore
    return this.data.map( row => [DataState.Delete, DataState.Insert, DataState.Update].includes(row.get_Status()))
  }
}
